
<template>
  <accordion-simple-item title="Regeln" :flex="true" v-if="userData?.isAdmin">
    <div class="flex flex-grow flex-col overflow-hidden h-full">
      <TRInput v-model="searchRule" type="text" placeholder="Regel suchen..." class="p-2 w-full my-2"
               data-ui="search-rule-input"></TRInput>
      <button @click="navigateTo(`/administration/${accordionIndex}/createRule`)"
              class="p-1 bg-white mb-4 mt-2  w-full hover:bg-trader-blue hover:text-white"
              data-ui="create-new-rule">
        Neue Regel erstellen
      </button>
      <div class=" overflow-auto " data-ui="rule-list">
        <div v-for="(rule, index) in filteredRules" :key="rule.id" :data-ui="'rule-'+ rule.id"
             @click="navigateTo(`/administration/${accordionIndex}/rule`, { ruleId: rule.id })"
             class="w-full p-1  flex my-2 cursor-pointer"
             :class="{ 'bg-trader-blue text-white': ruleId == rule.id, 'bg-trader-dark-gray': teamId != rule.id }">
            <span class="px-2  rounded text-center">
              {{ rule.title }}
            </span>
        </div>
      </div>
    </div>
  </accordion-simple-item>
</template>

<script setup>

import {computed, getCurrentInstance, onBeforeUnmount, onMounted, ref, watch} from "vue";
import AccordionSimpleItem from "@/components/Accordion/AccordionSimpleItem.vue";
import TRInput from "@/components/Base/TRInput.vue";
import {query} from "@/graphql";
import router from "@/router";
import {mapState} from "vuex";

const ruleId = ref(0)
const rules = ref([])
const { proxy } = getCurrentInstance();


const props = defineProps({
  accordionIndex: Number
})

import { useStore } from 'vuex'
import SignalBus from "@/application/SignalBus";

const store = useStore()

const userData = computed(() => store.state.user.userData)

const searchRule = ref('')
const filteredRules = computed(() => {
  return rules.value.filter((rule) => {
    let value ='' + searchRule.value || '';
    let name = '' + rule.name || '';
    return name.toLowerCase().includes(value.toLowerCase())
  })


})

async function getRules() {
  try {
    // get getRules
    const [data, err] = await query.getRules();
    if (err) {
      console.error(err);
      return;
    }
    rules.value = data
  } catch (e) {
    console.error(e)
  }
}


function navigateTo(route, params = {}) {
  let path = route;
  // Aufbau des Pfades basierend auf übergebenen Parametern
  if (Object.keys(params).length) {
    const paramParts = Object.keys(params).map(key => params[key]);
    path += '/' + paramParts.join('/');
  }
  router.push(path);
}

onMounted(() => {
  getRules()
  SignalBus.connect(proxy, 'reload-administration-sidebar', getRules);
})

onBeforeUnmount(() => {
  SignalBus.disconnectAllFromParent(proxy);
});

</script>